module.exports = __webpack_public_path__ + "05_bob_gold.a26928b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/05_bob_gold.png
// module id = JYgh
// module chunks = 0